import axios from "axios";

const API_URL = "https://api.suuplink.suave.ppg.br/api/";

const postScript = async ({ idId, script, admin }) => {
  return await axios({
    method: "post",
    url: API_URL + `admin/pages/${idId}/script`,
    data: script,
    headers: {
      "Content-Type": "application/json",
      "x-access-token": admin.accessToken,
    },
  });
};

const deleteScript = async ({ idId, admin, scriptId }) => {
  return await axios({
    method: "delete",
    url: API_URL + `admin/pages/${idId}/script/${scriptId}`,
    headers: {
      "x-access-token": admin.accessToken,
    },
  });
};

const scriptService = {
  postScript,
  deleteScript,
};

export default scriptService;
